import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TrustCenterFacadeService, FrameworkResponse } from '@anecdotes/shared-trust-center';
import { getCurrentlyVisibleObjects } from '../../../../utils';

@Component({
  selector: 'app-frameworks-edit-side-panel',
  templateUrl: './frameworks-edit-side-panel.component.html',
  styleUrls: ['./frameworks-edit-side-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FrameworksEditSidePanelComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'h-full';

  frameworks$: Observable<FrameworkResponse[]>;

  constructor(private trustCenterFacadeService: TrustCenterFacadeService) {}

  ngOnInit(): void {
    this.frameworks$ = getCurrentlyVisibleObjects(of(true), this.trustCenterFacadeService.getFrameworks(), 'position');
  }

  buildTranslationKey(relativeKey: string): string {
    return `trustCenter.${relativeKey}`;
  }
}
